import { IAppVersion } from '../domains/AppVersion';
import { api } from './api';

interface IUpdateAppVersionPayload {
  min_version: string;
  latest_version: string;
  update_url: string | null;
}

class AdminAppVersionsService {
  private apiService = api;

  public async getAll() {
    return this.apiService.get<IAppVersion[]>('admin/app-versions');
  }

  public async update(id: string, data: IUpdateAppVersionPayload) {
    return this.apiService.put<IAppVersion>(`admin/app-versions/${id}`, data);
  }
}

export { AdminAppVersionsService };
